import React, { Component } from "react";

class SaveCostSheetView extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <div>
                Save Cost Sheet View
            </div>
        );
    }
}

export default SaveCostSheetView;
